/**
 * Der Service Worker (CLAUDE.md §7: „Start aus dem Cache unter 2 Sekunden").
 *
 * Er haelt die ganze Anwendung vor -- HTML, JavaScript, Stile, Symbole und
 * die grossen Teile, die nur bei Bedarf geladen werden: die WebAssembly des
 * Scanners, `bwip-js` und `pdf-lib` fuer den Etikettendruck (ADR 0008). Ohne
 * sie gingen Scannen auf dem iPhone und Etikettendruck offline nicht.
 * Antworten der API haelt er **nicht** vor: Die Daten liegen in der lokalen
 * Datenbank, und zwei Zwischenspeicher fuer dieselben Daten laufen
 * irgendwann auseinander.
 *
 * Eine neue Fassung wird nicht ungefragt eingespielt. Wer gerade eine
 * Gitterbox scannt, soll nicht mitten im Durchgang eine neu geladene Seite
 * vor sich haben. Die Kopfzeile zeigt einen Hinweis zum Antippen -- kein
 * Dialog, keine Entscheidung, die jemand treffen muss (CLAUDE.md §7).
 */

import { useSyncExternalStore } from "react";
import { registerSW } from "virtual:pwa-register";

let neueFassung = false;
let einspielen: ((neuLaden?: boolean) => Promise<void>) | null = null;
const beobachter = new Set<() => void>();

export function dienstRegistrieren(): void {
  if (!("serviceWorker" in globalThis.navigator)) return;
  einspielen = registerSW({
    onNeedRefresh() {
      neueFassung = true;
      for (const b of beobachter) b();
    },
    onRegisterError(fehler: unknown) {
      console.error("Service Worker nicht registriert", fehler);
    },
  });
}

/** Liegt eine neue Fassung bereit? */
export function useNeueFassung(): boolean {
  return useSyncExternalStore(
    (b) => {
      beobachter.add(b);
      return () => beobachter.delete(b);
    },
    () => neueFassung,
  );
}

/**
 * Die neue Fassung einspielen und neu laden. Die Warteschlange liegt in
 * IndexedDB und uebersteht das.
 */
export function neueFassungEinspielen(): void {
  void einspielen?.(true);
}
